import { Component, Input, OnChanges } from '@angular/core';
import { Activity } from '../models';

@Component({
  selector: 'app-weather-box',
  templateUrl: './weather-box.component.html',
  styleUrls: ['./weather-box.component.scss'],
})
export class WeatherBoxComponent implements OnChanges {

  @Input() activity: Activity;
  @Input() mapId = 'mapId';
  @Input() weather;
  @Input() isImperial = false;

  activityMinutes;

  constructor() { }

  ngOnChanges() {
    //this.weather.weather.condition.code = 1003;
    //this.weather.weather.is_day = 0;
    this.activityMinutes = Math.floor(this.activity.moving_time/60) +'\'';
  }

}

